// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretRightOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretRightOutlined";
import AntdIcon from '../components/AntdIcon';

var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightOutlinedSvg
  }));
};

CaretRightOutlined.displayName = 'CaretRightOutlined';
export default React.forwardRef(CaretRightOutlined);